import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const CTA = () => {
  return (
    <section className="py-24 relative overflow-hidden bg-dark-ellipse">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15) 1px, transparent 1px),
                           radial-gradient(circle at 70% 70%, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Floating Elements */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-white/10 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#8bcaf9]/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-5 py-2 mb-8 border border-white/20">
          <Sparkles className="w-4 h-4 text-white" />
          <span className="text-white text-sm font-medium">Transforma tu negocio hoy</span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          ¿Listo para transformar tu negocio de{' '}
          <span className="text-[#e3e4e6]">suscripciones</span>?
        </h2>

        <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          Únete a más de 500 empresas que ya están automatizando su comercio cloud con Asisant.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/contacto?source=demo">
            <Button
              size="lg"
              className="bg-white hover:bg-[#e3e4e6] text-[#1297fd] font-semibold px-10 py-6 rounded-full text-lg transition-all hover:scale-105 hover:shadow-xl group"
            >
              Solicitar demo
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <Link to="/contacto?source=ventas">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white/30 text-white hover:bg-white/10 px-10 py-6 rounded-full text-lg transition-all hover:scale-105 bg-transparent"
            >
              Contactar ventas
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;
